import { render, staticRenderFns } from "./CustomerCustomerAccessActive.vue?vue&type=template&id=1034fd97"
import script from "./CustomerCustomerAccessActive.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerAccessActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports